import { getMonth } from 'date-fns';
import { TFunction } from 'i18next';
import { ROI } from '../fundListOptions';

export const getChooseButtonAriaLabel = (fundName: string, t: TFunction, isSelected = false) =>
    isSelected ? t('fund-list.chosen-aria-label', { fundName }) : t('fund-list.choose-aria-label', { fundName });

export const getPeriodText = (rateKey: ROI, t: TFunction): string => {
  const isYtd = rateKey === ROI.YTD;
  const monthsCount = isYtd
    ? getMonth(new Date()) + 1
    : Number.parseInt(rateKey.replace(/\D/g, ''), 10);

  return isYtd ? t('fund-period.ytd') : t('fund-period.months', { count: monthsCount });
};
